export default __webpack_public_path__ + "static/media/folio-icon.e80efb60.svg";